import React from 'react';
import BoardColumnComp from './column';
import {Draggable } from "react-beautiful-dnd";
import BoardConst from '../../utils/constants/board';
import { getActivityIssueTypesFilterOptions } from '../../utils';
import { isColumnItemVisible } from '../../utils/columnVisibility';

const getItemStyle = (isDragging: boolean, draggableStyle:any) => {
    let style = {
        userSelect: "none",
        ...draggableStyle,
    }
    if(isDragging){
        let containerCoordinates = document.querySelector(".mainBoardContainer").getBoundingClientRect();
        style.top = containerCoordinates.top + 10;

        if(draggableStyle.transform){
        
            let trArray = draggableStyle.transform.substring(10, draggableStyle.transform.length -1).split(",");
            let transX = draggableStyle.left + parseInt(trArray[0].trim().substring(0, trArray[0].length-2));
            let transY = style.top + parseInt(trArray[1].trim().substring(0, trArray[1].length-2));
    
            if(transY < containerCoordinates.top ){
                if(transX > containerCoordinates.left){
                    style.transform = `translate(${transX - draggableStyle.left}px, -${style.top-(containerCoordinates.top)}px)`;
                }else{
                    style.transform = `translate(-${draggableStyle.left-containerCoordinates.left}px, -${style.top-(containerCoordinates.top)}px)`;
                }
                
            }else if(transX < containerCoordinates.left){
                style.transform = `translate(-${draggableStyle.left-containerCoordinates.left}px, ${transY - style.top}px)`;
            }else{
                style.transform = draggableStyle.transform;
            }
        }
    }
    return style;
};

const isDraggableDisabled = (props: any) => {
    const { board, actions } = props;
    const { columns, tagId, userPermission } = board.boardDetails;
    const { boardType } = board.boardDetails;
    const { boardView } = board;
    if (boardType == 2) {
        let entityId;
        if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
          entityId = tagId;
        } else {
          entityId = board.boardDetails.board.id;
        }
        if (
          boardView == BoardConst.BOARD_VIEW_ACTIVITY ||
          userPermission.editBoard == "1"
        ) {
          return false;
        }
    }
    return true;
}

const ColumnList = (props: any) => {
    const { boardDetails, boardView, boardFilters } = props.board;
    let {columns = [], boardType} = boardDetails;
    let columnsData = JSON.parse(JSON.stringify(columns));
    if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
        if (boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) {
            columnsData = columnsData.filter((column: any) => column.visible == 'off');
        }
        // Item-level filtering is shared with the drag-reorder action via
        // isColumnItemVisible so both operate on the exact same projection (MR-8165).
        const visibilityCtx = {
            boardView,
            boardType,
            boardFilters,
            issueTypeOptionsCount: getActivityIssueTypesFilterOptions().length,
        };
        columnsData = columnsData.map((column: any) => {
            column.data = column.data.filter((d: any) => isColumnItemVisible(d, visibilityCtx));
            return column;
        });
    }

    return (
        <>
            {
                columnsData.map((col: any, index: number) =>
                <Draggable key={`col-${col.id}`} draggableId={`col-drag-${col.id}`} index={index} isDragDisabled={isDraggableDisabled(props)} >
                {
                    (provided: any, snapshot: any) => (
                    <div {...provided.draggableProps} ref={provided.innerRef} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                        <BoardColumnComp columnItem={col} {...props} dragHandleProps={provided.dragHandleProps} isDragging={snapshot.isDragging} />
                    </div>
                    )
                }
                </Draggable>
                )
            }
        </>
    );
}

export default ColumnList;
